module.exports = __webpack_public_path__ + "media/images/front/about/icon02-8ad9c0bf9589b69783e35a32e0b11b74.png";